export default {
    DRAFT: 100,
    INACTIVE: 200,
    ACTIVE: 300,
    SUSPENDED: 400
}
